// extracted by mini-css-extract-plugin
export default {"skipButton":"SkipButton_skipButton__CLbh+"};